const quantize: (quantity: number, word: { singular: string, plural: string }) => string = (quantity, word) => {
  if (quantity === 1) {
    return quantity + ' ' + word.singular;
  }
  else {
    return quantity + ' ' + word.plural;
  }
};

export default quantize;
